import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Grid } from "@mui/material";
import "../../../../assets/styles/audio-question.css";
import Image from "../../../ui-components/Image";
import Audio from "../../../ui-components/Audio";

export default function MultipleChoiceAudio({ question, onAnswer = () => {} }) {
    const theme = useTheme();
    const [selectedAnswers, setSelectedAnswers] = React.useState("");

    React.useEffect(() => {
        setSelectedAnswers("");
    }, [question]);

    const handleSetAnswer = (ansText) => {
        setSelectedAnswers(ansText);
        onAnswer({
            canProceed: ansText !== "",
            answer: ansText,
        });
    };

    return (
        <React.Fragment>
            <Box
                className="choices-container"
                sx={{ px: 4, textAlign: "center" }}
            >
                
				{question.questionAudio && (
					<Audio audioText={question.questionAudio} />
				)}

                {question.questionList.map((k, i) => (
                    <Grid
                        container
                        sx={{ mt: 2 }}
                        key={`audio-question-${i}-${Math.random()}`}
                    >
                        {k.choices.map((choice, j) => (
                            <Grid
                                item
                                sm={12}
                                xs={12}
                                sx={{
                                    mt: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "10px",
                                }}
                                className={`audio-question-container ${
                                    selectedAnswers === choice.value
                                        ? "active"
                                        : ""
                                }`}
                                key={`choice-${j}-${Math.random()}`}
                                onClick={() => handleSetAnswer(choice.value)}
                            >
                                <Typography
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        color:
                                            selectedAnswers === choice.value
                                                ? "white"
                                                : theme.palette.primary.main,
                                        fontWeight: "bold",
                                        p: 1,
                                        cursor: "pointer",
                                    }}
                                >
                                    <Image
                                        src={choice.image}
                                        value={choice.value}
                                        style={{
                                            width: "4rem",
                                            minWidth: "4rem",
                                            minHeight: "3rem",
                                            Height: "4rem",
                                            marginRight: "1rem",
                                        }}
                                    />
                                    {choice.label || choice.value}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                ))}
            </Box>
        </React.Fragment>
    );
}
